export function trackEvent(
  name: string,
  props?: Record<string, unknown>
): void {
  const defaultProps = {
    branch: process.env.BRANCH,
  };

  const finalProps = { ...defaultProps, ...props };

  if ("plausible" in window && typeof window.plausible === "function") {
    window.plausible(name, { props: finalProps });
  }

  if (window.location.hostname === "localhost") {
    console.log("trackEvent", name, finalProps);
  }
}
